/**
 * Accordion / expander driven by `[is-extendable-trigger]` and
 * `[is-extendable-target]`.
 *
 * @deprecated the `is-extendable-*` attribute contract is retired. No successor
 *   is named here — pick the accordion mechanism your project already uses.
 *   Also needs cash-dom, which not every consumer installs.
 *   Still BUNDLED into every project that imports the xlib.js barrel, which
 *   imports it statically — but nobody imports it by name.
 * @see Consumers 2026-07-30: none. Removable when this list is empty.
 */
import $ from 'cash-dom';
import Element from '../lib/Element';

export default class XlibExtendableElement extends Element {
    init() {
        this.triggers = this.ref.find('[is-extendable-trigger]');
        this.targets = {};

        this.ref.find('[is-extendable-target]').map((index, el) => {
            el = $(el);
            this.targets[el.attr('is-extendable-target')] = el;
        });
    }

    initListeners() {
        this.triggers.on('click.extendable', e => this.toggle(e.target));
    }

    toggle(el) {
        el = $(el);
        const index = el.attr('is-extendable-trigger');

        if (!this.targets[index]) {
            return;
        }

        if (this.isExtended(el, index)) {
            this.close(el, index);
            return false;
        }
        this.open(el, index);
        return false;
    }

    open(el, index) {
        el.attr('is-open', 'true');
        this.targets[index].css('display', 'block');
    }

    close(el, index) {
        el.attr('is-open', 'false');
        this.targets[index].css('display', 'none');
    }

    isExtended(el, index) {
        return el.is("[is-open='true']");
    }
}
